import { render, staticRenderFns } from "./RacetrackInformations.vue?vue&type=template&id=08b5f8c2&scoped=true&"
import script from "./RacetrackInformations.vue?vue&type=script&lang=js&"
export * from "./RacetrackInformations.vue?vue&type=script&lang=js&"
import style0 from "./RacetrackInformations.vue?vue&type=style&index=0&id=08b5f8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5f8c2",
  null
  
)

export default component.exports